module.exports = __webpack_public_path__ + "img/logo_512.77ff15cb.png";